
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ranking/books",
      function () {
        return require("private-next-pages/ranking/books/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ranking/books"])
      });
    }
  